import { render, staticRenderFns } from "./EditTextAlfanumericoConfig.vue?vue&type=template&id=3ce7f1fe&scoped=true"
import script from "./EditTextAlfanumericoConfig.vue?vue&type=script&lang=js"
export * from "./EditTextAlfanumericoConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce7f1fe",
  null
  
)

export default component.exports